
export const buildBiometricLogsPipeline = (parsedDateRanges, userIDs, employeeId) => {
    
    const pinMatch = { pin: { $in: userIDs.length ? userIDs : [] } };
    // const employeeIdMap = Object.fromEntries(employeeId);
  
    const dateRangeConditions = parsedDateRanges
      .filter(range => range && range.parsed)
      .map(({ parsed }) => ({
          $and: [
            { $gte: ["$timestamp", { $toDate: parsed.startDate }] },
            { $lte: ["$timestamp", { $toDate: parsed.endDate }] },
          ],
    }));

    const dateRangeCondition = !dateRangeConditions.length
      ? { $expr: { $eq: [1, 0] } } 
      : { $expr: { $or: dateRangeConditions } };
  
    return [
      { $match: { timestamp: { $ne: null }, ...pinMatch } },
      { $match: dateRangeCondition },
      { $sort: { timestamp: 1 } },
      {
        $addFields: {
          date: {
            $dateToString: { date: "$timestamp", format: "%Y-%m-%d" },
          },
        },
      },
      {
        $group: {
          _id: {
            userID: "$pin",
            date: "$date",
            status: "$status",
          },
          minStamp: { $min: "$timestamp" },
          maxStamp: { $max: "$timestamp" },
          doc: { $first: "$$ROOT" },
        },
      },
        {
          $replaceRoot: {
            newRoot: {
              $mergeObjects: [
                "$doc",
                {
                status: "$_id.status",
                  stampDate: {
                    $cond: [
                      { $in: ["$_id.status", [1, "1", 2, "2"]] },
                      "$maxStamp",
                      "$minStamp",
                    ],
                  },
                },
              ],
            },
          },
        },
      {
        $addFields: {
          date: {
            $dateToString: { date: "$stampDate", format: "%Y-%m-%d" },
          },
        },
      },
      {
        $group: {
          _id: {
            userID: "$pin",
            date: "$date",
            scheduleUpdate: "$scheduleUpdate",
            twentyFourSeven: "$twentyFourSeven",
          },
          docs: { $push: "$$ROOT" },
        },
      },
      {
        $replaceRoot: {
          newRoot: {
            userID: "$_id.userID",
            date: "$_id.date",
            
            stampDate: {
              $toDate: { $concat: ["$_id.date", "T00:00:00.000Z"] },
            },
            timeIn: {
              $ifNull: [
                {
                  $let: {
                    vars: {
                      d: {
                        $arrayElemAt: [
                          {
                            $filter: {
                              input: "$docs",
                              as: "x",
                              cond: { $in: ["$$x.status", [0, "0"]] },
                            },
                          },
                          0,
                        ],
                      },
                    },
                    in: {
                      $cond: [
                        { $and: [{ $ne: ["$$d", null] }, { $ne: ["$$d.stampDate", null] }] },
                        { $dateToString: { date: "$$d.stampDate", format: "%H:%M:%S" } },
                        "--:--",
                      ],
                    },
                  },
                },
                "--:--",
              ],
            },
            timeOut: {
              $ifNull: [
                {
                  $let: {
                    vars: {
                      d: {
                        $arrayElemAt: [
                          {
                            $filter: {
                              input: "$docs",
                              as: "x",
                              cond: { $in: ["$$x.status", [1, "1"]] },
                            },
                          },
                          0,
                        ],
                      },
                    },
                    in: {
                      $cond: [
                        { $and: [{ $ne: ["$$d", null] }, { $ne: ["$$d.stampDate", null] }] },
                        { $dateToString: { date: "$$d.stampDate", format: "%H:%M:%S" } },
                        "--:--",
                      ],
                    },
                  },
                },
                "--:--",
              ],
            },
            timeAmOut: {
              $ifNull: [
                {
                  $let: {
                    vars: {
                      d: {
                        $arrayElemAt: [
                          {
                            $filter: {
                              input: "$docs",
                              as: "x",
                              cond: { $in: ["$$x.status", [2, "2"]] },
                            },
                          },
                          0,
                        ],
                      },
                    },
                    in: {
                      $cond: [
                        { $and: [{ $ne: ["$$d", null] }, { $ne: ["$$d.stampDate", null] }] },
                        { $dateToString: { date: "$$d.stampDate", format: "%H:%M:%S" } },
                        "--:--",
                      ],
                    },
                  },
                },
                "--:--",
              ],
            },
            timePmIn: {
              $ifNull: [
                {
                  $let: {
                    vars: {
                      d: {
                        $arrayElemAt: [
                          {
                            $filter: {
                              input: "$docs",
                              as: "x",
                              cond: { $in: ["$$x.status", [3, "3"]] },
                            },
                          },
                          0,
                        ],
                      },
                    },
                    in: {
                      $cond: [
                        { $and: [{ $ne: ["$$d", null] }, { $ne: ["$$d.stampDate", null] }] },
                        { $dateToString: { date: "$$d.stampDate", format: "%H:%M:%S" } },
                        "--:--",
                      ],
                    },
                  },
                },
                "--:--",
              ],
            },
            timeRecStats: {
              $reduce: {
                input: "$docs",
                initialValue: [],
                in: {
                  $setUnion: [
                    "$$value",
                    { $ifNull: ["$$this.timeRecStats", []] },
                  ],
                },
              },
            },
            scheduleUpdate: "$_id.scheduleUpdate",
            twentyFourSeven: "$_id.twentyFourSeven",
          },
        },
      },
      // Compute employeeId once per document (from biometric userID → employeeId map)
      // {
      //   $addFields: {
      //     employeeId: {
      //       $let: {
      //         vars: {
      //           mapArray: { $objectToArray: { $literal: employeeIdMap } },
      //         },
      //         in: {
      //           $let: {
      //             vars: {
      //               matched: {
      //                 $arrayElemAt: [
      //                   {
      //                     $filter: {
      //                       input: "$$mapArray",
      //                       as: "item",
      //                       cond: { $eq: ["$$item.k", "$userID"] },
      //                     },
      //                   },
      //                   0,
      //                 ],
      //               },
      //             },
      //             in: "$$matched.v",
      //           },
      //         },
      //       },
      //     },
      //   },
      // },
      // Group by (employeeId, date) to deduplicate lookups
      // {
      //   $group: {
      //     _id: {
      //       employeeId: "$employeeId",
      //       date: "$date",
      //     },
      //     logs: { $push: "$$ROOT" },
      //   },
      // },
      // Lookup effective schedule ONCE per unique (employeeId, date) combination
      // {
      //   $lookup: {
      //     from: "selected_schedule_assignment",
      //     let: {
      //       employeeId: "$_id.employeeId",
      //       dateKey: "$_id.date",
      //     },
      //     pipeline: [
      //       {
      //         $match: {
      //           $expr: {
      //             $and: [
      //               { $ne: ["$$employeeId", null] },
      //               {
      //                 $or: [
      //                   { $eq: ["$employeeId", "$$employeeId"] },
      //                   {
      //                     $eq: [
      //                       { $toString: "$employeeId" },
      //                       { $toString: "$$employeeId" },
      //                     ],
      //                   },
      //                 ],
      //               },
      //               {
      //                 $lte: [
      //                   {
      //                     $cond: {
      //                       if: { $eq: [{ $type: "$created" }, "date"] },
      //                       then: {
      //                         $dateToString: {
      //                           date: "$created",
      //                           format: "%Y-%m-%d",
      //                         },
      //                       },
      //                       else: {
      //                         $cond: {
      //                           if: { $eq: [{ $type: "$created" }, "string"] },
      //                           then: {
      //                             $substr: ["$created", 0, 10],
      //                           },
      //                           else: { $toString: "$created" },
      //                         },
      //                       },
      //                     },
      //                   },
      //                   "$$dateKey",
      //                 ],
      //               },
      //             ],
      //           },
      //         },
      //       },
      //       {
      //         $addFields: {
      //           // Convert created to date for proper sorting
      //           createdDate: {
      //             $cond: {
      //               if: { $eq: [{ $type: "$created" }, "date"] },
      //               then: "$created",
      //               else: {
      //                 $cond: {
      //                   if: { $eq: [{ $type: "$created" }, "string"] },
      //                   then: { $toDate: "$created" },
      //                   else: null,
      //                 },
      //               },
      //             },
      //           },
      //         },
      //       },
      //       { $sort: { createdDate: -1 } },
      //       { $limit: 1 },
      //       {
      //         $project: {
      //           scheduleArray: 1,
      //           name: 1,
      //           selectedOption: 1,
      //           sequence: 1,
      //           startingDate: 1,
      //         },
      //       },
      //     ],
      //     as: "effectiveSchedule",
      //   },
      // },
      // {
      //   $addFields: {
      //     effectiveSchedule: {
      //       $arrayElemAt: ["$effectiveSchedule", 0],
      //     },
      //   },
      // },
      // Lookup effective twenty_fourSeven_assignment ONCE per unique (employeeId, date) combination
      // {
      //   $lookup: {
      //     from: "twenty_fourSeven_assignment",
      //     let: {
      //       employeeId: "$_id.employeeId",
      //       dateKey: "$_id.date",
      //     },
      //     pipeline: [
      //       {
      //         $match: {
      //           $expr: {
      //             $and: [
      //               { $ne: ["$$employeeId", null] },
      //               {
      //                 $or: [
      //                   { $eq: ["$employeeId", "$$employeeId"] },
      //                   { $eq: [{ $toString: "$employeeId" }, { $toString: "$$employeeId" }] },
      //                 ],
      //               },
      //               {
      //                 $lte: [
      //                   {
      //                     $cond: {
      //                       if: { $eq: [{ $type: "$created" }, "date"] },
      //                       then: {
      //                         $dateToString: {
      //                           date: "$created",
      //                           format: "%Y-%m-%d",
      //                         },
      //                       },
      //                       else: {
      //                         $cond: {
      //                           if: { $eq: [{ $type: "$created" }, "string"] },
      //                           then: {
      //                             $substr: ["$created", 0, 10],
      //                           },
      //                           else: { $toString: "$created" },
      //                         },
      //                       },
      //                     },
      //                   },
      //                   "$$dateKey",
      //                 ],
      //               },
      //             ],
      //           },
      //         },
      //       },
      //       {
      //         $addFields: {
      //           // Convert created to date for proper sorting
      //           createdDate: {
      //             $cond: {
      //               if: { $eq: [{ $type: "$created" }, "date"] },
      //               then: "$created",
      //               else: {
      //                 $cond: {
      //                   if: { $eq: [{ $type: "$created" }, "string"] },
      //                   then: { $toDate: "$created" },
      //                   else: null,
      //                 },
      //               },
      //             },
      //           },
      //         },
      //       },
      //       { $sort: { createdDate: -1 } },
      //       { $limit: 1 },
      //       {
      //         $project: {
      //           created: 1,
      //           employeeId: 1,
      //           name: 1,
      //         },
      //       },
      //     ],
      //     as: "effectiveTwentyFourSeven",
      //   },
      // },
      // {
      //   $addFields: {
      //     effectiveTwentyFourSeven: {
      //       $arrayElemAt: ["$effectiveTwentyFourSeven", 0],
      //     },
      //   },
      // },
      // Unwind logs and add effectiveSchedule and effectiveTwentyFourSeven to each log
      // {
      //   $unwind: "$logs",
      // },
      // {
      //   $replaceRoot: {
      //     newRoot: {
      //       $mergeObjects: [
      //         "$logs",
      //         {
      //           effectiveSchedule: "$effectiveSchedule",
      //           // effectiveTwentyFourSeven: "$effectiveTwentyFourSeven",
      //         },
      //       ],
      //     },
      //   },
      // },
      // // Remove scheduleId field (only keep effectiveSchedule)
      // {
      //   $project: {
      //     scheduleId: 0,
      //     employeeId: 0,
      //   },
      // },
      // { $sort: { stampDate: -1 } },
    ];
  };
